import { Head } from "@inertiajs/react"

import BrandLockup from "@/components/tuw/auth/BrandLockup"
import UsageAgreementText from "@/components/tuw/onboarding/UsageAgreementText"

// The platform usage agreement, read-only and public, at
// /post-project/usage-agreement: the guest account screen's agreement links here
// (guest-wording §3), since today's copy is shown only to signed-in customers
// at /customer/terms. The heading is the agreement's own link label.
export default function OpenHouseAgreement() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <Head title="Platform Usage Agreement · The Urban Writers" />
      <header className="border-b border-border bg-card px-8 py-3.5 max-[561px]:px-4">
        <BrandLockup className="h-[26px]" />
      </header>
      <main className="flex justify-center px-4 py-12">
        <div className="flex w-full max-w-[720px] flex-col gap-5">
          <h1 className="font-display text-[26px] font-bold tracking-tight">Platform Usage Agreement</h1>
          <UsageAgreementText boxed={false} />
        </div>
      </main>
    </div>
  )
}
